import PageContainer from '@/common/components/PageContainer'
import CreateBankAccountListing from '@/modules/bank/components/CreateBankAccount/components/CreateBankAccountListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function CreateBankAccountPage() {
	return (
		<PageContainer>
			<CreateBankAccountListing />
		</PageContainer>
	)
}

const GuardedCreateBankAccountPage = withUserPermission(CreateBankAccountPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_BANK_ACCOUNT],
})

export default GuardedCreateBankAccountPage
